import React, { Component } from 'react';
import LoadableComponent from '../../common-components/PlaceholderLoading/LoadableComponent';
import ContentLoadPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadPlaceholder';
import ContentLoadErrorPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript'
import { Configuration } from '../../types/Configuration'

type Props = {
    configuration: Configuration
    selectedLanguage: string,
    tokenIsProvided: boolean,
    onLoadCallback: () => void,
    onErrorCallback: () => void
}

type State = {
    scriptsToBeLoaded: LoadScript[]
    message?: string
}

class DocuwareId extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: []
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.configuration
            && this.props.configuration
            && prevProps.configuration.accountWebComponentBaseUrl !== this.props.configuration.accountWebComponentBaseUrl
        ) {
            this.setState({
                scriptsToBeLoaded: [
                    ...this.state.scriptsToBeLoaded,
                    { url: `${this.props.configuration.accountWebComponentBaseUrl}/build/my-account-docuware-id.esm.js`, type: "module", nomodule: false },
                    { url: `${this.props.configuration.accountWebComponentBaseUrl}/build/my-account-docuware-id.js`, type: "text/javascript", nomodule: true },
                ]
            })
        }
    }

    componentDidMount() {
        this.setState({
            scriptsToBeLoaded: [
                ...this.state.scriptsToBeLoaded,
                { url: `${this.props.configuration.accountWebComponentBaseUrl}/build/my-account-docuware-id.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.accountWebComponentBaseUrl}/build/my-account-docuware-id.js`, type: "text/javascript", nomodule: true },
            ]
        })
    }

    render() {
        const message = <Translation>{t => t(`Unfortunately we could not load "Account".`)}</Translation>;

        return (
            <LoadableComponent
                loadPlaceholder={ContentLoadPlaceholder}
                errorPlaceholder={ContentLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                {... this.props}>
                <my-account-docuware-id
                    language={this.props.selectedLanguage}
                    base-url={this.props.configuration.accountWebComponentBaseUrl}
                    token-is-provided={this.props.tokenIsProvided}>
                </my-account-docuware-id>
            </LoadableComponent>
        )
    }
}

export default DocuwareId;